import React from "react";
import NavbarClass from "../NavbarClass";
import Footer from "../footer/Footer";
import BookCard from "./BookCard";
import BookModal from "./BookModal";
import booksData from "./booksData";
import { pageview } from "../../utils/googleAnalyticsUtils";
import { InView } from "react-intersection-observer";
import "./Books.css";

class Books extends React.Component {
  state = {
    selectedBook: null,
  };

  componentDidMount() {
    pageview("Books");
  }

  openBookModal = (book) => {
    this.setState({ selectedBook: book });
  };

  closeBookModal = () => {
    this.setState({ selectedBook: null });
  };

  render() {
    const liveBooks = booksData.filter((book) => book.isLive);
    const comingSoonBooks = booksData.filter((book) => !book.isLive);

    return (
      <div className="books-page-outer">
        <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />

        {/* Hero */}
        <div className="books-hero">
          <div className="container">
            <h1 className="books-hero-heading">Our Books</h1>
            <p className="books-hero-subheading">
              Value-based stories your kids will love to read, again and again.
            </p>
          </div>
        </div>

        <div className="container books-content-container">
          {/* Available Now */}
          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div
                ref={ref}
                className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}
              >
                <h2 className="hp-section-heading">Available Now</h2>
                <div className="books-featured-wrapper">
                  {liveBooks.map((book) => (
                    <BookCard book={book} key={book.id} />
                  ))}
                </div>
              </div>
            )}
          </InView>

          {/* Coming Soon */}
          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div
                ref={ref}
                className={`hp-animate hp-animate--up delay-2 ${inView ? "is-visible" : ""}`}
              >
                <h2 className="hp-section-heading mt-5">Coming Soon</h2>
                <div className="books-grid">
                  {comingSoonBooks.map((book) => (
                    <BookCard
                      book={book}
                      key={book.id}
                      onClick={() => this.openBookModal(book)}
                    />
                  ))}
                </div>
              </div>
            )}
          </InView>
        </div>

        <Footer />

        <BookModal
          book={this.state.selectedBook}
          show={!!this.state.selectedBook}
          onHide={this.closeBookModal}
        />
      </div>
    );
  }
}

export default Books;
